export default __webpack_public_path__ + "static/media/image001.d342288d.png";